import React, { Component, Fragment } from "react";
import { Link} from 'react-router-dom';
import TimeAgo from 'react-timeago';

import { connect } from "react-redux";
import { getSuccesss, setSuccess, removeSuccess } from "../../store/actions";

import { confirmAlert } from 'react-confirm-alert';  
import 'react-confirm-alert/src/react-confirm-alert.css'; 


class AllSuccess extends Component {
constructor(props) {
super(props);

}



componentWillMount() {
  const { getSuccesss } = this.props;

  getSuccesss();


}


actionNow =  ( e, action ) => { 
  const { history, setSuccess, removeSuccess } = this.props;

if( action == "delete") {


  confirmAlert({
    title: 'Confirm',
    message: `Are you sure you want to remove ${ e.user }`,
    buttons: [
      {
        label: 'Yes',
        onClick: () => removeSuccess( { id : e.id } )
      },
      {
        label: 'No',
        onClick: () => {}
      }
    ]
  });



  
} else {
  setSuccess( e );  
history.push(`./${action}`);
 
}
 
}




render() {

const  {  successs }  = this.props;
return <>

  <div
    className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
    <h1 className="h2">Successs</h1>
    <div className="btn-toolbar mb-2 mb-md-0">
      <div className="btn-group mr-2">

      </div>
      <Link to={ `new` } className="btn btn-sm btn-outline-secondary  ">
      <i className="icofont-ui-add mr-2"></i>
      New Success
      </Link>
    </div>
  </div>




<div className="row"> 

  <div className="col">
{
  successs ?
  successs.length < 1 ?

 <div className="w-100 text-center">
 <div className="alert alert-warning"> 

<p className="m-0">nothing to show.</p>

</div>

   </div> :




    <div className="table-responsive">

  


    <table className="table">
      <thead className="thead-dark">
        <tr>
          <th scope="col">#</th>
          <th scope="col">Title</th>
          <th scope="col">Youtube Key</th>
          <th scope="col">description</th>
          <th scope="col">User</th>
          <th scope="col">Time</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>

      {
        successs.map( ( each, index) => 
          <tr key={ index } youtube={ index }>
            <th scope="row">{index + 1}</th>
            <td>{ each.title }</td>
            <td>{ each.youtube }</td>
            <td>{ each.description }</td>
            <td>{ each.user }</td>
            <td><TimeAgo date={each.date } /></td>
            <td>
<div className="btn-group" role="group" aria-label="Basic example">
  <button onClick={ e => this.actionNow( each, "view" ) } type="button" className="btn btn-primary btn-sm"><i className="icofont-eye-alt"></i></button> 
  <button onClick={ e => this.actionNow( each, "delete" ) } type="button" className="btn btn-danger btn-sm"><i className="icofont-ui-delete"></i></button>
  <button onClick={ e => this.actionNow( each, "edit" ) } type="button" className="btn btn-warning text-white btn-sm"><i className="icofont-ui-edit"></i></button>
</div>
            </td>
          </tr> 
          )
      } 
      </tbody>
    </table>





    </div>





: ""
}


  </div>

</div>

</>

}
}




export default connect(store => ({
auth: store.auth,
successs: store.successs
}), { getSuccesss, setSuccess, removeSuccess })(AllSuccess);